import React, { useLayoutEffect } from 'react';

/**
 * Schreibt JSON-LD als <script type="application/ld+json"> in den <head>.
 * Direkt im DOM, damit react-snap es beim Vorrendern übernimmt; je id genau ein Script.
 */
const StructuredData: React.FC<{ id: string; data: object }> = ({ id, data }) => {
  const json = JSON.stringify(data);

  useLayoutEffect(() => {
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = json;
    return () => { document.getElementById(id)?.remove(); };
  }, [id, json]);

  return null;
};

export default StructuredData;
